import { createContext, useContext } from 'react'
import type { ActivityState } from '../types'

export type ActivityContextValue = {
  state: ActivityState
  updateField: (stepId: string, key: string, value: string) => void
  updateInstructionProgress: (stepId: string, index: number) => void
  goToStep: (index: number) => void
  resetActivity: () => void
}

export const ActivityContext =
  createContext<ActivityContextValue | null>(null)

export function useActivity() {
  const context = useContext(ActivityContext)
  if (!context) {
    throw new Error(
      'useActivity deve ser usado dentro de ActivityProvider',
    )
  }
  return context
}
